// @ts-nocheck
import React from "react";
import { RedireccionView } from "../Componentes/RedireccionView";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useMediaQuery from '@mui/material/useMediaQuery';

export const Finalizado = () => {
    const matches = useMediaQuery('(max-width:600px)');

    return (
        <RedireccionView
            href={window.location.origin + '/'}
            titulo={"Los datos fueron guardados correctamente"}
            subtitulo={"Tenga en cuenta que su cuenta todavía no sido creada, sino que esta a la espera de ser confirmada para darla de alta, usted recibira un mail cuando ocurra dicho evento."}
            icono={matches ? <CheckBoxIcon sx={{ fontSize: 40 }} /> : <CheckBoxIcon sx={{ fontSize: 60 }} />}
        />
    )
}